import { AvatarDropdown, AvatarName, Footer,CustomSelectLang,ActionButton} from '@/components';
import {outLogin, queryCurrentUser} from '@/services/userApi';
import {BellFilled, BellOutlined, LinkOutlined, LogoutOutlined} from '@ant-design/icons';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import { SettingDrawer } from '@ant-design/pro-components';
import { history, Link } from '@umijs/max';
import React, {useEffect} from 'react';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import {setAuth, getAuth, clearAuth} from "@/utils/db";
// @ts-ignore
import {requestConfig} from '@/utils/request.js'
import {stringify} from "querystring";
import {Badge, Flex} from "antd";
import {getAllStatus} from "@/utils/utils";
import {flushSync} from "react-dom";


const isDev = process.env.NODE_ENV === 'development';
const accountPath = '/account';
const loginPath = "/user/login";

// 统一登录跳转（单页应用方式）
const gotoLogin = (logout?, arg = {}) => {
  const { pathname, query } = history.location;
  if (pathname?.startsWith("/user") && pathname !== loginPath) return;
  if (pathname !== loginPath) {
    const queryStr = Object.keys(query).length > 0 ? `?${stringify(query)}` : "";
    const redirect = encodeURIComponent(`${pathname}${queryStr}`);
    history.push({
      pathname: loginPath,
      query: { redirect, ...arg?.query },
    });
  }
};
// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await queryCurrentUser();
    return response.data;
  } catch (error) {
    gotoLogin();
    return undefined;
  }
};

/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const res = await queryCurrentUser();
      return res.data;
    } catch (error) {
      //history.push(loginPath);
    }
    return undefined;
  };


  // 如果不是登录页面，执行
  const { location } = history;
  const token= getAuth()
   if(token){
     const currentUser = await fetchUserInfo();
     return {
       fetchUserInfo,
       currentUser:{...currentUser,name:currentUser.user_name},
       settings: defaultSettings as Partial<LayoutSettings>,
     };
   }
  return {
    fetchUserInfo,
    currentUser:{},
    settings: defaultSettings as Partial<LayoutSettings>,
  };

}
// 初始化状态
async function initState() {
  const { location } = history;
  const token = getAuth();

  // 登录页面不执行用户信息获取
  if ([loginPath].includes(location.pathname)) {
    return { fetchUserInfo, settings: {} };
  }

  // 有 token 时尝试获取用户信息
  if (token) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser: currentUser ? { ...currentUser, name: currentUser.user_name } : undefined,
      settings: {},
    };
  }

  // 无 token 且非登录页，跳转登录
  gotoLogin();
  return { fetchUserInfo, currentUser: undefined, settings: {} };
}



// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: ({initialState, setInitialState}: { initialState: any; setInitialState: any }) => {
  layout: string;
  actionsRender: () => React.JSX.Element[];
  childrenRender: (children: any) => React.JSX.Element;
  bgLayoutImgList: any[];
  footerRender: () => React.JSX.Element;
  patchMenus:() => void;
  onPageChange: () => void;
  links: React.JSX.Element[];
  title: string;
  menu: { mode: string };
  avatarProps: { src: string | undefined; title: React.JSX.Element;
    render: (_: any, avatarChildren: any) => React.JSX.Element };
  breadcrumbRender: boolean
} = ({ initialState, setInitialState }) => {
  // 设置浏览器标题
  const browserTitle = '泛德在线模拟交易平台';
  const { currentUser } = initialState;

  useEffect(() => {
    document.title = browserTitle;
  }, []);


  useEffect(() => {
    if(currentUser?.mobile){
      getAllStatus(setInitialState)
    }
  }, [currentUser]);
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const logOut = async () => {
    flushSync(() => {
      setInitialState((s) => ({ ...s, currentUser: undefined }));
    });
    await outLogin();

    const { search, pathname } = window.location;
    const urlParams = new URL(window.location.href).searchParams;
    //清除一系列缓存
    clearAuth();
    /** 此方法会跳转到 redirect 参数所在的位置 */
    const redirect = urlParams.get('redirect');
    // Note: There may be security issues, please note
    if (window.location.pathname !== '/user/login' && !redirect) {
      history.replace({
        pathname: '/user/login',
        search: stringify({
          redirect: pathname + search,
        }),
      });
    }
  };

  return {
    ...initialState?.settings,
    logo:'/logo.png',
    title: browserTitle, // 使用字符串
    // 完全自定义菜单头渲染
    menuHeaderRender: (logo, title, menuHeaderDom) => {
      return (
          <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
            {logo}
            <div style={{ marginLeft: 8,fontSize:'1.67rem', fontWeight:700 }}>
              <span style={{
                color: 'var(--main-color)',
                borderRight: 'solid 0.33rem var(--main-color)',
                padding: '0 0.5rem',
                marginRight: '0.5rem',
              }}>
                泛德在线
              </span>
              <span>模拟交易平台</span>
            </div>
          </div>
      );
    },
    // menuHeaderRender:undefined,
    menu: {
      mode: 'horizontal', // 强制菜单水平显示，
    },
    layout: 'top', // 关键：设置为顶部导航
    breadcrumbRender: false, // 完全关闭面包屑
    actionsRender: () =>{
      const userAction =   currentUser?.mobile ?
          '':[<ActionButton type={'default'}  url='/user/login' text={'登录'} />,<ActionButton type={'primary'} url='/user/register' text={'立即注册'} />]
      return [...userAction]
    } ,
    avatarProps:currentUser && {
      children: currentUser?.real_name?.slice(0, 2) || currentUser?.mobile?.slice(0, 2),
      style: {
        backgroundColor: 'var(--main-color)',
        color: '#fff',
        width:'2.5rem',
        height: '2.5rem'
      },
      title: <AvatarName/>,
      render: (_, avatarChildren) => {
        return (
            <Flex style={{gap:'1rem'}}>
              <AvatarDropdown>{avatarChildren}</AvatarDropdown>
              {currentUser?.mobile &&
                  <><Badge dot={currentUser?.messageAllStatus === 2}>
                <a className={'icon-message'} onClick={()=>history.push("/account/message")}><BellFilled style={{fontSize:'1.33rem'}} /></a>
              </Badge>
              <div className={'icon-message'} onClick={()=> logOut()}><LogoutOutlined style={{color:'var(--main-color)', fontSize:'1.33rem'}} /></div></>}
            </Flex>
        );
      },
    },

    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      if(location.pathname.includes('/account/')){
        // $('.ant-pro-top-nav-header-menu').hide()
        // 如果没有登录，重定向到 login
        if (!initialState?.currentUser?.name) {
           history.push('/user/login');
        }
      }
    },
    bgLayoutImgList: [],
    links: isDev
      ? [
          <Link key="openapi" to="/umi/plugin/openapi" target="_blank">
            <LinkOutlined />
            <span>OpenAPI 文档</span>
          </Link>,
        ]
      : [],
    // menuHeaderRender: ()=><HeaderMenu />,
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState: any) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )}
        </>
      );
    },

  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  ...errorConfig,
  ...requestConfig
};
